import type { Product } from './product';

export const products: Product[] = [
    {
        ProductID: 1,
        ProductName: 'Chai',
        Description: '10 boxes x 20 bags',
    },
    {
        ProductID: 2,
        ProductName: 'Chang',
        Description: '24 - 12 oz bottles',
    },
    {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        Description: '12 - 550 ml bottles',
    },
    {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        Description: '48 - 6 oz jars',
    },
    {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        Description: '36 boxes',
    },
    {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        Description: '12 - 8 oz jars',
    },
    {
        ProductID: 7,
        ProductName: "Uncle Bob's Organic Dried Pears",
        Description: '12 - 1 lb pkgs.',
    },
    {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        Description: '12 - 12 oz jars',
    },
    {
        ProductID: 9,
        ProductName: 'Mishi Kobe Niku',
        Description: '18 - 500 g pkgs.',
    },
    {
        ProductID: 10,
        ProductName: 'Ikura',
        Description: '12 - 200 ml jars',
    },
];
